import 'manager-base/app-base/shim';
import angularRedux from '@buildium/angular-redux';
import {PublicAuthenticationRoutes} from './routes';
import {TwoFactorAuthenticationVerificationController} from './pages/two-factor-authentication-verification';
import {LoginController} from './pages/login/login';
import {LoginWithTokenController} from './pages/login-with-token/login-with-token';
import {VerifyTwoFactorAuthenticationComponent} from '../shared/components/verify-two-factor-authentication/verify-two-factor-authentication';
import {FingerprintingService} from '../../manager-base/fingerprinting/services/fingerprinting-service';
import {TwoFactorAuthenticationConstants} from '../shared/constants/two-factor-authentication';
import {ThemeSettingsConstants} from '../shared/constants/theme-settings';
import {AuthenticationErrorConstants} from '../shared/constants/authentication-error';
import {RevealPasswordComponent} from '../../manager-base/components/reveal-password/reveal-password';
import {SubscriberPickerComponent} from '../shared/components/subscriber-picker/subscriber-picker';
import { LoaderModule } from '@buildium/angularjs-core/dist/components/loader';
import {ChooseSubscriberController} from './pages/choose-subscriber/choose-subscriber';
import {LoginService} from './services/login-service';
import {ReCaptchaService} from './services/recaptcha-service';
import {PublicConstants} from '../constants/constants';
import {AdminAccessLevelPromptController} from './pages/admin-access-level-prompt/admin-access-level-prompt';
import {RedirectToLoginService} from '../../manager-base/app-base/config/redirect-to-login';
import {PublicPageLoadTiming} from '../../manager-base/app-base/run/public-page-load-timing';
import {ManagerPublicAuthenticationBaseModule} from '../../manager-base/app-base/public/authentication/manager-public-authentication-base.module';
import { PublicAppShellComponent } from '../../projects/public/src/ajs-app/core/app-shell/public-app-shell';
import { PublicEsignaturesModule } from './features/esignatures/public-esignatures.module';
import { SetupResponsiveAuthentication } from './setup-responsive-authentication.run';
import { ResponsiveLayoutService } from '../shared/services/responsive-layout.service';

const dependencies = [
    ManagerPublicAuthenticationBaseModule,
    LoaderModule,
    PublicEsignaturesModule.name
];

export const PublicAuthenticationApp = angularRedux.createApp('buildium.authentication', dependencies)
    .config(PublicAuthenticationRoutes)
    .service('FingerprintingService', FingerprintingService)
    .service('LoginService', LoginService)
    .service('RecaptchaService', ReCaptchaService)
    .service('RedirectToLoginService', RedirectToLoginService)
    .service('ResponsiveLayoutService', ResponsiveLayoutService)
    .controller('TwoFactorAuthenticationVerificationController', TwoFactorAuthenticationVerificationController)
    .controller('LoginController', LoginController)
    .controller('LoginWithTokenController', LoginWithTokenController)
    .controller('ChooseSubscriberController', ChooseSubscriberController)
    .controller('AdminAccessLevelPromptController', AdminAccessLevelPromptController)
    .component('publicAjsAppShell', PublicAppShellComponent)
    .component('bdVerifyTwoFactorAuthentication', VerifyTwoFactorAuthenticationComponent)
    .component('bdRevealPassword', RevealPasswordComponent)
    .component('bdSubscriberPicker', SubscriberPickerComponent)
    .constant('TwoFactorAuthenticationMethod', TwoFactorAuthenticationConstants.TwoFactorAuthenticationMethod)
    .constant('SeasonalBackgroundImageSource', ThemeSettingsConstants.SeasonalBackgroundImageSource)
    .constant('ReCaptchaProtectedAction', PublicConstants.ReCaptchaProtectedAction)
    .constant('AuthenticationError', AuthenticationErrorConstants)
    .constant('SuperUser', PublicConstants.SuperUser)
    .run(PublicPageLoadTiming)
    .run(SetupResponsiveAuthentication);
